import { SEARCH_INPUT_DEFAULTS } from '../../constants/ticketMgmt/manage-assignees/searchTypes';

export const adjustSearchInputsDefaultValues = history => {
    const {
        state: {
            prop,
            value
        } = { }
    } = history.location;

    return {
        ...SEARCH_INPUT_DEFAULTS,
        ...(value ? { [ prop ]: value } : { })
    };
};
